import { render } from "./CartCard.vue?vue&type=template&id=ab33f22a&scoped=true"
import script from "./CartCard.vue?vue&type=script&lang=js"
export * from "./CartCard.vue?vue&type=script&lang=js"

import "./CartCard.vue?vue&type=style&index=0&id=ab33f22a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/my_res/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab33f22a"]])

export default __exports__